import { render, staticRenderFns } from "./Recruitment.vue?vue&type=template&id=ea56bfc6&scoped=true&lang=pug&"
import script from "./Recruitment.vue?vue&type=script&lang=js&"
export * from "./Recruitment.vue?vue&type=script&lang=js&"
import style0 from "./Recruitment.vue?vue&type=style&index=0&id=ea56bfc6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea56bfc6",
  null
  
)

export default component.exports